import { render } from "./addTextIcon.vue?vue&type=template&id=1361c176"
import script from "./addTextIcon.vue?vue&type=script&lang=js"
export * from "./addTextIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__